<template>
  <li>
    <div class="shipping__method">
      <input type="radio" :id="shippingMethod['carrier_code']" name="shipping[method]" :checked="isActiveMethod" :value="shippingMethod['carrier_code']" @change="changeSelectedShippingMethod(shippingMethod)"/>
      <label :for="shippingMethod['carrier_code']">
        <span class="_title">
          {{ shippingMethod['carrier_title'] }}
          <span :class="{ _free: shippingMethod['price_incl_tax'] === 0 }">{{ shippingMethod['price_incl_tax'] === 0 ? $t('Free') : `&euro; ${shippingMethod['price_incl_tax'].toFixed(2)}` }}</span>
        </span>
        <span class="_sub">{{ shippingMethod['method_title'] }}</span>
      </label>
    </div>
  </li>
</template>

<script lang="ts">
  import {Component, Vue, Prop} from 'vue-property-decorator';

  @Component({
    name: 'checkout-shipping-methods-default'
  })

  export default class extends Vue {
    @Prop({required: true}) private shippingMethod: object;
    @Prop() private selectedShippingMethod: object;

    private get isActiveMethod(): boolean {
      return (this.selectedShippingMethod || {})['carrier_code'] === this.shippingMethod['carrier_code'];
    }

    private changeSelectedShippingMethod(method): void {
      this.$store.dispatch('CheckoutShipping/setShippingMethod', method);
    }
  }
</script>
